<template lang="pug">
  v-container.pa-0(style="max-width: 800px;")
    head-bar
    div.basic300
      .invoice-info.mx-2.py-4
        p.p2.mb-0.mt-0.mx-2(:class="lead.paid ? 'primary500--text' : 'primary500--text'") {{ lead.paid ? 'Amount paid' : 'Invoice Balance' }}
            template.mx-2(v-if="lead.paid")
              div.h1.success--text Paid 

            template(v-else)
              div.h1.primary500--text {{ amountDue | displayPrice($currency) }}
              div(v-if="$route.query.error")
                div.p2.danger500--text.mt-2 Payment failed
                v-chip.mt-2(color="textColorAccent" small label link @click="verifyPayment()" dark) Verify again
                  v-icon(right size=14) mdi-refresh
                v-chip.mt-2.ml-2(v-if="$route.query.retry" color="textColorAccent" small label link @click="reportPayment()" dark :disabled="reportBtnState == 'sending' || reportBtnState == 'done'") Report payment issue
                  v-icon(v-if="reportBtnState == 'pending'" right size=14) mdi-send
                  v-progress-circular.ma-auto.ml-2(v-if="reportBtnState == 'sending'" :width="2" :size="12" color="white" indeterminate)
                  v-icon(v-if="reportBtnState == 'done'" right size=14) mdi-check
              div.p2.primary400--text(v-else) Due date : {{this.invoice.extra_data.invoice_valid_until | humanizeDate}}
    v-card(tile elevation=0 style="border: 1px solid var(--v-basic300);" v-if="lead" :style="isPrinting? 'min-height: 96vh; border-radius: 0' : 'min-height: 96vh;'" :class="isPrinting? 'elevation-0': ''")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      v-card-text(v-else :class="isPrintingSmall ? 'py-4 px-0' : 'pa-4'")
        v-form(ref="form")
          .payment-details.text-left.mt-4
            div.d-flex
              div.s1.primary500--text Payment
              v-spacer
              div
                v-btn.text-uppercase.my-auto.button-AA-tiny.white--text(v-if="hasPaymentMethod" small label color="textColorAccent" depressed block @click="clickPay" :disabled="(outOfStock && !singlePageCheckout) || isInvoiceExpired")
                  | Make Payment
            div.p2.primary500--text Keep track of all your payment
            .have-payment(v-if="invoice.payments")
              div.py-3.my-2(:style="`background-color: var(--v-basic300); border-radius: 4px`")
                div.px-3.pt-2(v-for="i in invoice.payments")
                  div.d-flex
                    div.p2.primary500--text(v-if="i.description=='Deposit'") {{i.description}}
                    div.p2.primary500--text(v-else-if="i.gateway=='billplz'") FPX payment
                    div.p2.primary500--text(v-else) Manual Payment
                    v-spacer
                    div
                      div.p2.primary500--text {{i.amount | displayPrice}}
                        v-icon.ml-5(
                      small outlined
                      color="basic600"
                      @click="downloadReceipt(i)"
                    ) mdi-download
                  div.c1.basic600--text {{i.paid_datetime | humanizeDate}}
            .no-payment(v-else)
              div.py-3.my-2(:style="`background-color: var(--v-basic300); border-radius: 4px`")
                div.text-center.pa-2
                  v-icon.mr-2.align-center(right size=24 style="vertical-align: middle;") mdi-clipboard-outline
                div.c1.primary--text.ml-2.text-center No Payment recorded. Start making
                div.c1.primary--text.ml-2.text-center payment and they will show up here.

          .client-details.text-left.mt-6
            div.s1.primary500--text Invoice details
            v-row.pa-0
              v-col.pr-0(cols=2)
                div.p2.mb-1.basic600--text To
                div.p2.mb-1.basic600--text From
                div.p2.mb-1.basic600--text Invoice
              v-col.pl-0(cols=10)
                div.p2.mb-1.primary500--text {{ lead.name }}
                div.p2.mb-1.primary500--text ARBA Travel & Tours Sdn Bhd
                div.p2.mb-1.primary500--text {{this.invoice.rid}}
          
          .client-details.text-left.mx-2
            div.s2.primary500--text Travel Details
            v-divider.my-1.basic300

            v-simple-table(dense)
              thead
                tr
                  th.pa-0(style="border: none")
                    div.p2.basic600--text.text-start.mr-1 Description
                  th.pa-0(v-if="!isPrintingSmall" style="border: none")
                    div.p2.basic600--text.text-end.mx-1 Price
                  th.pa-0(style="border: none")
                    div.p2.basic600--text.text-end.ml-1 Amount
              tbody
                template(v-for="p in invoice.products")
                  tr(:key="p.id")
                    td.text-start.pa-0(style="border: none; vertical-align:top;")
                      div.my-1
                        div.p2.primary500--text.mr-1 {{ p.quantity }} x {{ getName(p) }} {{ p.addons.length > 0 ? ' set' : '' }}
                        div.c1.danger500--text(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid && lead.status !== 'partial_payment'") {{ p.product.inventory_qty > 0 ? `Only ${p.product.inventory_qty} left in stock` : 'Sold out' }}
                        div.ml-3
                          //- VARIANT NAME
                          template(v-if="sameVariantParentName(p)")
                            div.c1.mt-1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ p.product.name }}
                          //- ADDON LIST
                          template(v-if="p.addons.length > 0")
                            div.c1.mr-1.mt-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ p.name }}
                            div(v-for="(a, idx) in p.addons" :key="'addon-' + idx")
                              div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                              div.c1.danger500--text(v-if="a.inventory_enabled && a.inventory_qty < a.quantity && !lead.paid && lead.status !== 'partial_payment'") {{ a.inventory_qty > 0 ? `Only ${a.inventory_qty} left in stock` : 'Sold out' }}
                          //- BUNDLE LIST
                          template(v-if="p.bundles.length > 0")
                            div.mt-1(v-for="(b, idx) in p.bundles" :key="'bundle-' + idx")
                              div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ idx + 1 }}. {{ b.name }}
                              //- BUNDLE PRODUCT NOTES
                              div(v-if="b.product_notes_data && b.product_notes_data.length > 0")
                                div(v-for="note in b.product_notes_data" :key="note.id")
                                  div.c1.mx-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") - 
                                    strong {{ note.name }}: 
                                    | {{ note.data }}
                              div.c1.danger500--text(v-if="b.product.inventory_enabled && b.product.inventory_qty < b.quantity && !lead.paid") {{ b.product.inventory_qty > 0 ? `Only ${a.inventory_qty} left in stock` : 'Sold out' }}
                          //- PRODUCT NOTES
                          div.mt-1(v-if="p.product_notes_data && p.product_notes_data.length > 0")
                            div(v-for="note in p.product_notes_data" :key="note.id")
                              div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'")
                                strong {{ note.name }}: 
                                | {{ note.data }}

                    td.text-end.pa-0(v-if="!isPrintingSmall" style="border: none; min-width: 70px; vertical-align:top;")
                      div.my-1
                        div.p2.primary500--text.mx-1 {{ p.price_per_set | displayPrice($currency) }}
                        div.mt-3(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid")
                        template(v-if="p.addons.length > 0")
                          div.c1.basic600--text.mx-1.mt-1 {{ p.price | displayPrice($currency) }}
                          template(v-for="a in p.addons")
                            div.c1.basic600--text.mx-1 {{ a.price * a.quantity_per_set | displayPrice($currency) }}
                    td.text-end.pa-0(style="border: none; min-width: 70px; vertical-align:top;")
                      div.my-1.p2.primary500--text.ml-1 {{ p.price_per_set * p.quantity | displayPrice($currency) }}
            v-divider.my-1.basic300


          div.mx-2.mt-4
            div.d-flex.mt-1
              div.p2.primary400--text Subtotal
              v-spacer
              div.p2.primary400--text {{ subtotalPrice | displayPrice($currency) }}
            div.d-flex.mt-2(v-if="discountPrice")
              div.p2.primary400--text Discount
              v-spacer
              div.p2.primary400--text {{ discountPrice | displayPrice($currency) }}
            div.d-flex.mt-2(v-if="promoDiscountPrice")
              div.p2.primary400--text Promo Discount
              v-spacer
              div.p2.primary400--text {{ promoDiscountPrice | displayPrice($currency) }}
            div.d-flex.mt-2
              div.p2.primary400--text Tax
              v-spacer
              div.p2.primary400--text {{ taxAmount }}%
            div.d-flex.align-center.mt-1(v-if="shippingFee !== null && !lead.pickup")
              div.p1.primary400--text Delivery Charge:
              v-spacer
              div.p1.primary400--text(v-if="shippingFee === 0")
                v-chip.px-1(color="success500" small label outlined)
                  v-icon(small).pr-1 mdi-truck-fast
                  | Free Shipping
              div.p1.primary400--text(v-else) {{ shippingFee | displayPrice($currency) }}
            div.d-flex.mt-1(v-if="serviceFee")
              div.p2.primary400--text Service Fee
              v-spacer
              div.p2.primary400--text {{ serviceFee | displayPrice($currency) }}
            div.d-flex.mt-2
              div.h6.primary--text Total
              v-spacer
              div.h6.primary--text {{ totalPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p2.primary400--text Amount Paid
              v-spacer
              div.p2.primary400--text {{ totalPaid | displayPrice($currency) }}

            .installment(v-if="lead.installment && !lead.paid")
              div.d-flex.py-2.ml-n2.mr-n2.mt-1(:style="`background-color: ${$vuetify.theme.themes[$theme].dangerT16}; border-radius: 4px`")
                div.h6.primary--text.ml-2 Balance Due
                v-spacer
                div.h6.primary--text.mr-2 {{ amountDue | displayPrice($currency) }}


          div.pt-6(v-if="!lead.paid && !lead.cod && !lead.pay_at_shop && lead.status != 'reject'")
            v-btn.button-AA-medium.white--text(v-if="hasPaymentMethod" color="textColorAccent" depressed block @click="clickPay" :disabled="(outOfStock && !singlePageCheckout) || isInvoiceExpired") {{ singlePageCheckout ? 'Checkout' : 'Pay now' }}
            div.caption.danger500--text.mt-2(v-if="outOfStock") Not enough stock available. Change your order quantity or consult with seller.
            div.caption.danger500--text.mt-2(v-if="isInvoiceExpired") This invoice has expired
          v-btn.button-AA-medium.white--text.mt-2( color="textColorAccent" outlined block depressed height=32 @click="generateInvoicePDF") Download Invoice

    .modals
      parcel-history-dialog(v-if="showParcelHistoryDialog" :open.sync="showParcelHistoryDialog" :lead="lead" :shipping="lead.shipping")
      apply-coupon-dialog(v-if="showApplyCouponDialog" :open.sync="showApplyCouponDialog" :invoice="invoice" @applied="getInvoice")

      y-dialog(v-if="showSetAmountDialog" v-model='showSetAmountDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.center Choose Payment Option
          v-divider.basic300
          v-card-text.pa-4
            v-btn.button-AA-medium.white--text(v-if="!this.invoice.extra_data.booking_paid" block color='textColorAccent' depressed height=32 @click='clickPayBookingAmount()' :loading="isLoading")
              div Pay Booking Amount
            v-form(ref="form")
              // p.mb-1.label.basic600--text Insert Any Amount 
              v-text-field.mt-2(v-if="this.invoice.extra_data.booking_paid" v-model='paymentAmount' :placeholder="$t('price.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="priceRules" :prefix="$currency.symbol")
            v-btn.button-Aa-medium.white--text(v-if="this.invoice.extra_data.booking_paid" outlined block color='textColorAccent' depressed height=32 @click='clickPayPartialAmount()' :loading="isLoading" text)
              | Pay Any Amount
            div.text-center.mt-1.p2 or
            v-btn.button-AA-medium.white--text(v-if="!this.invoice.extra_data.booking_paid" block color='textColorAccent' depressed height=32 @click='clickPayFullAmount()' :loading="isLoading" text)
              div(v-if="lead.status == 'partial_payment'") Pay remaining amount
              div(v-else) Pay full amount
            v-btn.button-AA-medium.white--text(v-else block color='textColorAccent' depressed height=32 @click='clickPayFullAmount()' :loading="isLoading")
              div(v-if="lead.status == 'partial_payment'") Pay remaining amount
              div(v-else) Pay full amount

</template>

<script>
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import ReceiptTemplate from '@/views/invoice/components//ReceiptTemplate.vue'
import ParcelHistoryDialog from '@/views/invoice/components/ParcelHistoryDialog'
import ApplyCouponDialog from '@/views/invoice/components/ApplyCouponDialog'
import LinkifyText from '@/components/LinkifyText.vue'
import HeadBar from '@/components/forms/HeadBar.vue'
import { mapActions } from 'vuex'
import axios from 'axios'
export default {
  name: 'CustomerInvoice',
  components: { ParcelHistoryDialog, ApplyCouponDialog, LinkifyText, HeadBar,ReceiptTemplate },
  props: ['lead'],
  data: () => ({
    isFetching: true,
    invoice: null,
    company: null,
    bankList: [],
    zones: [],
    showParcelHistoryDialog: false,
    showSetAmountDialog: false,
    showApplyCouponDialog: false,
    paymentAmount: null,
    isLoading: false,
    singlePageCheckout: false,
    reportBtnState: 'pending',
    rules: {
      not_empty: [
        val => val != null || 'This field is required',
        val => val > 0 || 'This field is required'
      ]
    }
  }),
  computed: {
    isPrinting () {
      if (this.$route.path.includes('print-invoices') || this.$route.path.includes('print-invoices-small')) {
        return true
      }
      return false
    },
    isPrintingSmall () {
      if (this.$route.path.includes('print-invoices-small')) {
        return true
      }
      return false
    },
    isEditable () {
      if (this.lead.paid) {
        return false
      }
      if (this.lead.cod) {
        return false
      }
      if (this.lead.pay_at_shop) {
        return false
      }
      if (this.lead.installment && this.lead.status == 'partial_payment') {
        return false
      }
      if (this.lead.status === 'reject') {
        return false
      }
      return true
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v >= this.minPaymentAmount/this.$currency.multiplier || `Amount should not be below ${this.$currency.symbol} ${(parseFloat(this.minPaymentAmount/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
        v => v <= this.amountDue/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.amountDue/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    },
    outOfStock() {
      if (this.lead.status === 'partial_payment') return false
      if (!this.invoice) return false
      for (let i = 0; i < this.invoice.products.length; i++) {
        let p = this.invoice.products[i]
        if (p.product.inventory_enabled && p.product.inventory_qty < p.quantity) {
          return true
        }
      }
      return false
    },
    shippingFee() {
      if (!this.invoice) return 0
      return this.invoice.shipping_fee
    },
    discountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_discount
    },
    promoDiscountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_promo_discount
    },
    subtotalPrice() {
      if (!this.invoice) return 0
      return this.invoice.subtotal_amount
    },
    serviceFee() {
      if (!this.invoice) return 0
      return this.invoice.service_fee
    },
    totalPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_amount
    },
    totalPaid() {
      if (!this.invoice) return 0
      return this.invoice.total_paid
    },
    amountDue() {
      if (!this.invoice) return 0
      return this.invoice.total_amount - this.invoice.total_paid
    },
    taxAmount() {
      if (!this.invoice) return 0
      return this.invoice.company.tax_rate
    },
    minPaymentAmount() {
      if (!this.invoice.minimum_payment) return 0
      if (this.invoice.minimum_payment > this.amountDue) {
        return this.amountDue
      }
      return this.invoice.minimum_payment
    },
    hasPaymentMethod () {
      if (this.company && this.company.default_payment_gateway) return true
      if (this.bankList.length > 0) return true
      if (this.lead.allow_cod) {
        return true
      }
      if (this.lead.allow_pay_at_shop) {
        return true
      }
      return false
    },
    isInvoiceExpired() {
      if (!this.invoice.extra_data.invoice_valid_until) {
        return false; // If there's no expiration date, consider the invoice as not expired
      }

      const today = new Date();
      const validUntil = new Date(this.invoice.extra_data.invoice_valid_until);

      // Strip the time components for accurate date-only comparison
      const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const validUntilDate = new Date(validUntil.getFullYear(), validUntil.getMonth(), validUntil.getDate());

      // Check if validUntilDate is strictly less than todayDate
      return validUntilDate < todayDate;
    },
    hasTrackingCode () {
      if (this.lead.shipping && (this.lead.shipping.tracking_id || this.lead.shipping.shipping_method === 'easyparcel')) {
        return true
      }
      return false
    },
    bankAccountNumber () {
      if (!this.invoice || !this.invoice.products) return '5628 3463 1641'

      // Check if any product name contains "BT"
      const hasBTProduct = this.invoice.products.some(product =>
        product.name && product.name.includes('BT')
      )

      return hasBTProduct ? '5622 6362 2627' : '5628 3463 1641'
    }
  },
  mounted () {
    this.fetchCompanyGenes()
    this.fetchRequiredInfo()
    if (!this.lead.paid) {
      this.fetchBankAccount()
    }
    this.company = this.lead.form.company
    if (this.$route.name === 'DownloadInvoicePDF') {
      this.$nextTick(() => {
        this.generateInvoicePDF()
      })
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getStringFromAddress (address) {
      return `${address.address_1},${address.address_2 ? ` ${address.address_2},` : ''} ${address.postcode},${address.area ? ` ${address.area}, ${address.suburb},` : ''} ${address.city}, ${address.state}, ${address.country}`
    },
    getCouponErrorMessage (error) {
      if (this.$t(`coupon_error.${error.state}`).includes('coupon_error') ) {
        return this.$t('coupon_error.default')
      } else if (error.state === 'invoice_datetime') {
        let condition = 'is not ready yet'
        if (error.operator === 'lte') {
          condition = 'is expired'
        }
        return this.$t('coupon_error.invoice_datetime', { condition: condition})
      } else if (error.state === 'subtotal_no_tax') {
        return this.$t('coupon_error.subtotal_no_tax', { min_order: this.$options.filters.displayPrice(error.condition, this.$currency)})
      }
      return this.$t('coupon_error.default')
    },
    getInvoice () {
      this.isFetching = true
      this.$axios.get(`/invoices/${this.lead.pid}/`)
        .then((response) => {
          this.isFetching = false
          this.invoice = response.data
        })
        .catch(() => {})
    },
    fetchBankAccount () {
      this.$axios.get(`/leads/${this.lead.pid}/directpay/`)
        .then((response) => {
          response.data.results.forEach(bank => {
            if (bank.enabled) {
              this.bankList.push(bank)
            }
          })
        })
        .catch(() => {})
    },
    fetchRequiredInfo () {
      this.isFetching = true
      this.$axios.get(`/forms/${this.lead.form.slug}/zones`)
        .then((response) => {
          this.zones = response.data
        })
        .catch(() => {})
        .finally(() => {
          this.getInvoice()
        })
    },
    fetchCompanyGenes () {
      this.$axios.get(`/companies/${this.lead.company}/genes`)
        .then((response) => {
          if (response.data.filter(f => f.feature === 'YZ_CHECKOUT_V2').length > 0) {
            this.singlePageCheckout = true
          }
        })
        .catch(() => {})
    },
    getName (product) {
      if (product.product.variant_for) {
        if (this.sameVariantParentName(product)) {
          return product.name.replace(`(${product.product.name})`, '')
        }
      }
      return product.name
    },
    sameVariantParentName (product) {
      return product.name.includes(`(${product.product.name})`)
    },
    clickPay() {
      if (this.singlePageCheckout) {
        location.href = `https://checkout.${process.env.VUE_APP_BASE_DOMAIN}/checkout/${this.lead.pid}`
        return
      }
      if (!this.lead.shipping && this.zones.length > 0) {
        this.showMessage(['error', `Choose delivery to proceed for this order`])
        this.openDeliveryOption()
        return
      }
      if (this.lead.installment) {
        this.showSetAmountDialog = true
      } else {
        location.href = `/invoices/${this.lead.pid}/pay`
      }
    },
    clickPayPartialAmount() {
      if (!this.$refs.form.validate()) {
        return
      }
      const amountInCent = (parseFloat(this.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      location.href = `/invoices/${this.lead.pid}/pay?amount=${amountInCent}`
    },
    clickPayBookingAmount() {
      const amountInCent = (parseFloat(this.invoice.extra_data.booking_amount)).toFixed(this.$currency.exponent).replace('.', '')
      location.href = `/invoices/${this.lead.pid}/pay?amount=${amountInCent}`
    },
    clickPayFullAmount() {
      location.href = `/invoices/${this.lead.pid}/pay`
    },
    openDeliveryOption (){
      location.href = `/invoices/${this.lead.pid}/delivery`
    },
    openAddProducts () {
      location.href = `/invoices/${this.lead.pid}/catalogs`
    },
    startCopyOrder () {
      if (this.lead.member && this.lead.member.role === 'Agent') {
        this.$axios.get(`/forms/${this.lead.form.slug}?agent_member_id=${this.lead.member.id}`)
        .then((response) => {
          location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${response.data.slug}/?customer=${this.lead.pid}`
        })
        .catch(() => {})
        return
      }
      if (this.lead.form.type === 'store') {
        location.href = `https://${this.lead.form.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/?customer=${this.lead.pid}`
        return
      }
      location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.form.slug}/?customer=${this.lead.pid}`
    },
    verifyPayment() {
      this.$axios.post(`/leads/${this.lead.pid}/recheck_payments/`)
      .then(() => {
        if (this.lead.hostname) {
          location.href = `https://${this.lead.hostname}/invoices/${this.lead.pid}/verify?retry=true`
          return
        }
        location.href = `/invoices/${this.lead.pid}/verify?retry=true`
      })
    },
    reportPayment() {
      this.reportBtnState = 'sending'
      const params = new URLSearchParams()
      params.append('invoice', `https://${this.lead.hostname}/invoices/${this.lead.pid}` )
      params.append('lead_id', this.lead.id)
      params.append('company_id', this.lead.form.company.id)
      axios.post('https://hooks.zapier.com/hooks/catch/1847976/b3jbg4w/', params, { headers: {'Content-Type': 'application/x-www-form-urlencoded' } })
      .then(() => {
        this.showMessage(['success', this.$t('success_message.your_concern_reported')])
        this.reportBtnState = 'done'
      })
    },
    clickAskMerchat () {
      window.open(`https://api.whatsapp.com/send?phone=${this.lead.member.phone}`, '_blank')
    },
    chipBackgroundColor (status) {
      if (status === 'new') {
        return this.$vuetify.theme.themes[this.$theme].infoT08
      } else if (status === 'follow_up') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'partial_payment') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'reject') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'processed') {
        return this.$vuetify.theme.themes[this.$theme].successT08
      } else if (status === 'shipped') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'received') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'cancelled') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'error') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === '') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      }
      return this.$vuetify.theme.themes[this.$theme].basic600T08
    },
    downloadReceipt(payment) {
      const receiptData = {
        companyName: this.company.name,
        companyAddress: this.company.address,
        invoiceNumber: this.invoice.rid,
        invoiceAmount: this.$options.filters.displayPrice(this.invoice.total_amount),
        balanceAmount: this.$options.filters.displayPrice(this.invoice.total_amount - this.invoice.total_paid),
        paymentDate: this.$options.filters.humanizeDate(payment.paid_datetime),
        paymentAmount: this.$options.filters.displayPrice(payment.amount),
        paymentMethod: payment.gateway === 'billplz' ? 'FPX Payment' : (payment.description === 'Deposit' ? 'Deposit' : 'Manual Payment'),
        customerName: this.lead.name,
      }
      this.generateReceiptPDF(receiptData)
    },

    generateInvoicePDF() {
    const { jsPDF } = require("jspdf");
    require('jspdf-autotable');

    const doc = new jsPDF();

    const logoUrl = require('@/assets/logos/receiptlogo.png') // Replace with your actual logo path or URL
     
        
      doc.addImage(logoUrl, 'PNG', 100, 20, 80, 25) // Adjust size and position as needed
     
      
   
      doc.setFont('helvetica','bold')
      // Add company information
      doc.setFontSize(10)
      doc.text('ARBA Travel & Tours Sdn Bhd', 10, 20)
      doc.setFont('helvetica','normal')
      doc.text('K-3-01, IOI Conezion, IOI Resort City,', 10, 25)
      doc.text('Persiaran IRC 3, 62502 PUTRAJAYA', 10, 30)
      doc.text('cs@arbatravel.com', 10, 35)
      doc.text('Trade Reg. Nr. 1093130-M KPK/LN7886', 10, 40)
      doc.setFontSize(18)
      doc.setFont('helvetica','bold')
      doc.setTextColor(255, 0, 38)
      doc.text('INVOICE', 10, 60)

      doc.setFont('helvetica', 'bold')
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(10)
      doc.text(`Bill To : `, 10, 70)
      doc.setFont('helvetica', 'normal')
      doc.text(this.lead.name, 10, 75)
      doc.text(this.lead.email, 10, 80);
      doc.text(this.lead.phone, 10, 85);



    // Add invoice details
    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.text(`Invoice Number: ${this.invoice.rid}`, 150, 70);
    doc.text(`Due Date: ${this.$options.filters.humanizeDate(this.invoice.extra_data.invoice_valid_until)}`, 150, 75);


    // Add invoice items
    doc.autoTable({
      startY: 100,
      head: [['Description', 'Quantity', 'Price', 'Amount']],
      body: this.invoice.products.map(product => [
        product.name,
        product.quantity,
        this.$options.filters.displayPrice(product.price_per_set, this.$currency),
        this.$options.filters.displayPrice(product.price_per_set * product.quantity, this.$currency)
      ]),
       headStyles: {
        fillColor: [255, 217, 219], // RGB color for header background
        textColor: [255, 0, 38], // RGB color for header text
        fontStyle: 'normal',
        halign: 'left', // Horizontal alignment
        valign: 'middle' // Vertical alignment
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // RGB color for header background
        textColor: [0, 0, 0], // RGB color for header text
        fontStyle: 'normal',
        halign: 'left', // Horizontal alignment
        valign: 'middle' // Vertical alignment
      }
    });

    // Add totals
        const pageWidth = doc.internal.pageSize.width;
    const rightMargin = 15; // Adjust this value as needed
    const alignRightX = pageWidth - rightMargin;

    let yPos = doc.lastAutoTable.finalY + 10;
    
    doc.setFontSize(10);
    doc.setTextColor(0);

    // Helper function for right-aligned text
    const addRightAlignedText = (text, y) => {
      doc.text(text, alignRightX, y, { align: 'right' });
    };

    addRightAlignedText(`Subtotal: ${this.$options.filters.displayPrice(this.subtotalPrice, this.$currency)}`, yPos);
    yPos += 5;

    if (this.discountPrice) {
      addRightAlignedText(`Discount: ${this.$options.filters.displayPrice(this.discountPrice, this.$currency)}`, yPos);
      yPos += 5;
    }

    if (this.promoDiscountPrice) {
      addRightAlignedText(`Promo Discount: ${this.$options.filters.displayPrice(this.promoDiscountPrice, this.$currency)}`, yPos);
      yPos += 5;
    }

    addRightAlignedText(`Tax (${this.taxAmount}%): ${this.$options.filters.displayPrice(this.taxAmount * this.subtotalPrice / 100, this.$currency)}`, yPos);
    yPos += 5;

    if (this.shippingFee !== null && !this.lead.pickup) {
      addRightAlignedText(`Shipping: ${this.$options.filters.displayPrice(this.shippingFee, this.$currency)}`, yPos);
      yPos += 5;
    }

    if (this.serviceFee) {
      addRightAlignedText(`Service Fee: ${this.$options.filters.displayPrice(this.serviceFee, this.$currency)}`, yPos);
      yPos += 5;
    }
    addRightAlignedText(`Total: ${this.$options.filters.displayPrice(this.totalPrice, this.$currency)}`, yPos);
    yPos += 5;

    addRightAlignedText(`Amount Paid: ${this.$options.filters.displayPrice(this.totalPaid, this.$currency)}`, yPos);
    yPos += 5;

    doc.setTextColor(220, 0, 0);
    addRightAlignedText(`Balance Due: ${this.$options.filters.displayPrice(this.amountDue, this.$currency)}`, yPos);


    const footerY = doc.internal.pageSize.height - 60; // Adjust as needed

    // Add horizontal line
    

    doc.setFontSize(12);
    doc.setTextColor(0);
    doc.setFont("helvetica", "bold");
    doc.text("ARBA TRAVEL & TOURS SDN BHD", 10, footerY);


    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Maybank Islamic : ${this.bankAccountNumber}`, 10, footerY + 5);
    doc.text("Swift Code : MBBEMYKL", 10, footerY + 10);

    doc.setDrawColor(200);
    doc.line(10, footerY + 15, 200, footerY + 15);

    // Office Address
    doc.setFont("helvetica", "bold");
    doc.text("Office Address", 10, footerY + 30);
    doc.setFont("helvetica", "normal");
    doc.text("K-3-01, Conezion, Persiaran IRC3,", 10, footerY + 35);
    doc.text("IOI Resort City, 62502 Putrajaya", 10, footerY + 40);

    // Payment & General Inquiry
    doc.setFont("helvetica", "bold");
    doc.text("Payment & General Inquiry", 70, footerY + 30);
    doc.setFont("helvetica", "normal");
    doc.text("03-8687 4950", 70, footerY + 35);
    doc.text("hi@arbatravel.com", 70, footerY + 40);

    // Customer Support
    doc.setFont("helvetica", "bold");
    doc.text("Customer Support", 120, footerY + 30);
    doc.setFont("helvetica", "normal");
    doc.text("03-8408 1595", 120, footerY + 35);
    doc.text("cs@arbatravel.com", 120, footerY + 40);

    const awardLogo1 = require('@/assets/logos/award.png');
    doc.addImage(awardLogo1, 'PNG', 160, footerY + 20, 30, 30);


    // Save the PDF
    doc.save(`Invoice_${this.invoice.rid}.pdf`);
  },
    async generateReceiptPDF(data) {
      const doc = new jsPDF()
      
      // Add company logo
    // You need to have the logo as a base64 string or a URL
      const logoUrl = require('@/assets/logos/receiptlogo.png') // Replace with your actual logo path or URL
     
        
      doc.addImage(logoUrl, 'PNG', 100, 20, 80, 25) // Adjust size and position as needed
     
      
   
      doc.setFont('helvetica','bold')
      // Add company information
      doc.setFontSize(10)
      doc.text('ARBA Travel & Tours Sdn Bhd', 10, 20)
      doc.setFont('helvetica','normal')
      doc.text('K-3-01, IOI Conezion, IOI Resort City,', 10, 25)
      doc.text('Persiaran IRC 3, 62502 PUTRAJAYA', 10, 30)
      doc.text('cs@arbatravel.com', 10, 35)
      doc.text('Trade Reg. Nr. 1093130-M KPK/LN7886', 10, 40)
      doc.setFontSize(18)
      doc.setFont('helvetica','bold')
      doc.setTextColor(255, 0, 38)
      doc.text('Receipt', 10, 60)

      doc.setFont('helvetica', 'bold')
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(10)
      doc.text(`Received From : `, 10, 70)
      doc.setFont('helvetica', 'normal')
      doc.text(`${data.customerName}`, 10, 75)
      doc.setFont('helvetica','normal')
      doc.text(`Date: ${data.paymentDate}`, 150, 70)
      
      // Add receipt details
      doc.autoTable({
        startY: 100,
        head: [['Invoice Number', 'Original Amount', 'Current Balance', 'Payment']],
        body: [
          [data.invoiceNumber, data.invoiceAmount, data.balanceAmount, data.paymentAmount ],
        ],
        headStyles: {
        fillColor: [255, 217, 219], // RGB color for header background
        textColor: [255, 0, 38], // RGB color for header text
        fontStyle: 'normal',
        halign: 'center', // Horizontal alignment
        valign: 'middle' // Vertical alignment
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // RGB color for header background
        textColor: [0, 0, 0], // RGB color for header text
        fontStyle: 'normal',
        halign: 'center', // Horizontal alignment
        valign: 'middle' // Vertical alignment
      }
      })
      
      // Add footer
      doc.setFontSize(10)
      doc.text('This Receipt is digitally generated. No signature is needed.', 105, 280, null, null, 'center')
      
      // Save the PDF
      doc.save(`Receipt_${data.invoiceNumber}.pdf`)
    }
  }
}
</script>

<style scoped>
.dotted {
  border-top: 2px dashed var(--v-primary400);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.company-logo {
  width: 30%;
}
</style>

<i18n>
  {
    "en": {
      "price": {
        "label": "Amount",
        "placeholder": "0"
      },
      "coupon_error": {
        "default": "*Invalid coupon code",
        "invoice_datetime": "*This coupon {condition}",
        "subtotal_no_tax": "*Min order: {min_order}"
      }
    },
    "en": {
      "price": {
        "label": "Jumlah",
        "placeholder": "0"
      },
      "coupon_error": {
        "default": "*Kode Kupon tidak valid",
        "invoice_datetime": "*Kupon ini {condition}",
        "subtotal_no_tax": "*Min order: {min_order}"
      }
    }
  }
</i18n>
